module.exports = __webpack_public_path__ + "img/a24d19f.webp";